import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  // Ingles

  en: {
    general: {
      yes: "Yes",
      no: "No",
      unavailable: "Unavailable",
      locationToBeDefined: "Location to be determined",
      installments: "Installments",
      processingFee: "Processing Fee",
      processingFeeDescription:
        "The processing fee is intended to cover the financial cost related to the chosen payment method",
      document: "Document",
      number: "Number",
      phone: "Phone",
      cityUf: "City/State",
      roadAvenue: "Road, Avenue...",
      complement: "Complement",
      neighborhood: "Neighborhood",
      city: "City",
      state: "State",
      country: "Country",
      tickets: "Tickets",
      cep: "Zip Code",
    },

    header: {
      logout: "Logout",
      help: "Help",
    },

    cart: {
      tickets: "Tickets",
      ticket: "Ticket",
      continue: "Continue",
      doYouWishContinue: "Do you want to continue?",
      alertChangeSector:
        "When switching sectors, you will lose tickets already reserved.",
      yes: "Yes",
      keepBuying: "No, keep buying",
      removeReserved: "Remove Reserved Tickets?",
      cancelCartTitle: "Cancel Cart",
      cancelCartDescription: "Are you sure you want to cancel your cart?",
      locationMap: "Location Map",
      applyCoupon: "Apply a Code",
      nothingTickets: "No Ticket Selected",
      apply: "Apply",
      code: "Code ",
      closed: "Closed",
      subtitle: "Subtitle",
      proof: "* Proof may be requested on the day of the event.",
      specialSeats: "Special seats*",
      sectors: "Sectors",
      cartRemove: "Remove from cart",
    },

    summary: {
      yourOrder: "Your Order",
      nothingProducts: "No tickets selected.",
      edit: "Edit",
      confirm: "Confirm",
      balanceToPay: "Balance due",
      amountPaid: "Amount Paid",
      ticketsTotal: "Total Tickets",
      serviceTax: "Service fee",
    },

    preSale: {
      title: "This event is on Pre-Sale!",
      text: "Enter your special pre-order code below to start your purchase:",
    },

    participants: {
      participants: "Participants",
      details: "Name each ticket with whom you will access the event.",
      jump: "Skip",
      optional: "Optional. You can complete participant information later",
      back: "Back",
      continue: "Continue",
    },

    queue: {
      youAreInQueue: "You are in the virtual queue to purchase tickets",
      pageOpen: "Please keep this page open. No need to reload.",
      yourPosition: "Your position in the queue:",
      yourTurn: "Your turn has come!",
      chooseTickets: "Choose tickets...",
    },

    countdown: {
      finishBy: "Finish by",
    },

    changeBuyer: {
      change: "Change",
      changeBuyer: "Change Buyer",
      textOne:
        "In order to change your information, you will need to change your account data on the site.",
      textTwo:
        "If you would like to make this purchase with other buyer data, log out your account by clicking the button below:",
      logout: "Logout",
    },

    partialPayment: {
      amountPayable: "Amount Payable",
      sharePayment:
        "Share this payment with others by making a partial payment.",
      moreInfo: "More information",
      value: "Value",
      descriptionTitle:
        "To split the payment with other people, enter a partial amount in the amount to be paid field",
      descriptionOne:
        "Your payment will be processed and your purchase will remain pending until the full amount of the order has been paid.",
      descriptionTwo:
        "You will receive a link to share and allow others to add payments to your order.",
      close: "Close",
    },

    expiration: {
      expiredOrder: "Expired Order",
      text: "Please restart your purchase and secure your tickets!",
      close: "Close",
    },

    pixScreen: {
      choosePaymentMethod: "Choose another payment method",
      payWith: "Pay with",
      waitPlease: "Please wait...",
      copyCode: "Copy Code",
      finish:
        "After completing the payment, return to this screen to finalize the order.",
    },

    securityCheck: {
      invoice: "Invoice",
      authentication: "Purchase authentication",
      text: "To confirm your order, check your invoice or message sent by your bank for the 3-digit purchase authorization code:",
      cannotSee: "I couldn't find the code",
      cannotSeeTextOne:
        "In this case, we will cancel the pre-authorization made on the card ",
      cannotSeeTextTwo:
        ", and you can make the purchase with another payment method",
      changePaymentMethod: "Change payment method",
      whySeeing: "Why am I seeing this message?",
      becauseSeeing:
        "To confirm your payment, we need to authenticate that you are the holder of the card used for the purchase.",
    },

    payment: {
      purchasePolicy: "Purchase Policy",
      buyerData: "Buyer Data",
      howWantPay: "Payment",
      cancelFree: "Free cancellation until",
      notStored: "Don't worry! Your payment details will not be stored!",
      multipleParcelBillet: "Pay the first installment by the day",
      oneParcelBillet: "Pay within one business day",
      form: {
        fullName: "Full Name",
        corporateName: "Corporate Name",
        typeDocument: "Type Document",
        nationality: "nationality",
        passport: "Passport",
      },
      card: {
        creditCard: "Credit card",
        payBy: "Pay by ",
        installment: "Installments",
        includesInterestFrom: "Includes interest of ",
        number: "Card number",
        validDate: "Expiration date",
        securityCode: "Security code",
        securityCodeAbbrev: "Sec. Code",
        namePrinted: "Name printed on card",
        perMonth: "/mo",
      },
      billet: {
        title: "Billet",
        fullName: "Full Name",
        corporateName: "Corporate Name",
      },
    },

    finished: {
      organizerMessage: "Organizer's Message",
      eventOrganizedBy: "Event organized by",
      summaryOrder: "Summary of your Order #",
      accessEvent: "Access the event",
      orderPlaced: "Order placed!",
      orderAnalysis: "Order in analysis",
      courtesy: "Courtesy",
      courtesyText: "No charge has been made",
      detailsOrder: "Your purchase details have been sent to ",
      detailsOrderAnalysis:
        "Your payment is being analyzed with the card operator. We will send you a confirmation via email when your payment status changes.",
      digitalTicket: "Digital ticket",
      ticketsSent: "Your tickets have been sent to the email ",
      notReceived:
        "If you haven't received the email, log in/create your account to access your tickets.",
      seeTickets: "View Tickets",
      accessAccount: "Access Account",
      orderBalance: "This order still has a balance due of ",
      toSwitchOff: " to switch off",
      newPayment: "To make a new payment on this order, visit the link below",
      makeNewPayment: "Make new payment",
      copyLink: "Copy Link",
      billet: {
        payTheBill: "Pay the bill by the day ",
        pendingPayment: "Pending payment",
        threeDays: "Up to 3 business days for payment confirmation",
        seeBillet: "See ticket",
      },
      card: {
        youPay: "You paid ",
        analysis: "Under Analysis",
        approved: "Approved",
        inCard: "x on the card ending in ",
        purchaseReview:
          "Your purchase is under review. We will send you an email confirmation when your order status changes",
      },
      pix: {
        approved: "Approved",
        orderValue: "Value of the order: ",
      },
    },

    errors: {
      required: "Required field",
      invalid: " invalid",
      invalidDate: "Invalid date.",
      sixCharacters: "Minimum of 6 characters.",
    },
  },

  // PORTUGUES

  pt: {
    general: {
      yes: "Sim",
      no: "Não",
      unavailable: "Indisponível",
      locationToBeDefined: "Local a Definir",
      installments: "Parcelas",
      processingFee: "Taxa de Processamento",
      processingFeeDescription:
        "A taxa de processamento visa cobrir o custo financeiro relacionado com a forma de pagamento escolhida",
      document: "Documento",
      number: "Número",
      phone: "Telefone",
      cityUf: "Cidade/UF",
      roadAvenue: "Rua, Avenida...",
      complement: "Complemento",
      neighborhood: "Bairro",
      city: "Cidade",
      state: "Estado",
      country: "País",
      tickets: "Ingressos",
      cep: "CEP",
    },

    header: {
      logout: "Sair",
      help: "Ajuda",
    },

    cart: {
      tickets: "Ingressos",
      ticket: "Ingresso",
      continue: "Continuar",
      doYouWishContinue: "Deseja continuar mesmo assim?",
      alertChangeSector:
        "Ao trocar de setor, você vai perder os ingressos reservados até o momento.",
      yes: "Sim",
      keepBuying: "Não, manter a compra",
      removeReserved: "Remover Ingressos Reservados?",
      cancelCartTitle: "Cancelar Carrinho",
      cancelCartDescription: "Tem certeza que quer cancelar seu carrinho?",
      locationMap: "Mapa do local",
      applyCoupon: "Aplicar um Código",
      nothingTickets: "Nenhum Ingresso Selecionado",
      apply: "Aplicar",
      code: "Código ",
      closed: "Encerrado",
      subtitle: "Legenda",
      proof: "* Pode ser solicitado comprovação no dia do evento.",
      specialSeats: "Assentos especiais*",
      sectors: "Setores",
      cartRemove: "Remover do Carrinho",
    },

    summary: {
      yourOrder: "Seu Pedido",
      nothingProducts: "Nenhum ingresso selecionado ainda.",
      edit: "Editar",
      confirm: "Confirmar",
      balanceToPay: "Saldo a Pagar",
      amountPaid: "Valor Pago",
      ticketsTotal: "Total Ingressos",
      serviceTax: "Taxa de Serviço",
    },

    participants: {
      participants: "Participantes",
      details: "Nomeie cada ingresso com quem irá acessar o evento.",
      jump: "Pular",
      optional: "Opcional. Você pode completar os dados do participante depois",
      back: "Voltar",
      continue: "Continuar",
    },

    preSale: {
      title: "Este evento está em Pré-Venda!",
      text: "Insira abaixo seu código especial de pré-venda para iniciar a compra:",
    },

    queue: {
      youAreInQueue: "Você está na fila virtual para adquirir ingressos",
      pageOpen: "Mantenha esta página aberta. Não é necessário recarregar.",
      yourPosition: "Sua posição na fila:",
      yourTurn: "Sua vez chegou!",
      chooseTickets: "Escolha os ingressos...",
    },

    countdown: {
      finishBy: "Finalize em até",
    },

    expiration: {
      expiredOrder: "Pedido Expirado",
      text: "Por favor, reinicie sua compra e garanta seus ingressos!",
      close: "Fechar",
    },

    changeBuyer: {
      change: "Alterar",
      changeBuyer: "Alterar Comprador",
      textOne:
        "Para para alterar os seus dados será necessário alterar os dados da sua conta no site.",
      textTwo:
        "Caso queria realizar esta compra com outros dados de comprador, faça logout da sua conta clicando no botão abaixo:",
      logout: "Fazer Logout",
    },

    partialPayment: {
      amountPayable: "Valor a Pagar",
      sharePayment:
        "Divida este pagamento com outras pessoas fazendo um pagamento parcial.",
      moreInfo: "Mais informações",
      value: "Valor",
      descriptionTitle:
        "Para dividir o pagamento com outras pessoas, informe um valor parcial no campo valor a pagar",
      descriptionOne:
        "O seu pagamento será processado e sua compra continuará pendente até que o valor total do pedido seja pago",
      descriptionTwo:
        "Você receberá um link para compartilhar e permitir que outras pessoas adicionem pagamentos ao seu pedido",
      close: "Fechar",
    },

    pixScreen: {
      choosePaymentMethod: "Escolher outra forma de pagamento",
      payWith: "Pagar com",
      waitPlease: "Por favor Aguarde...",
      copyCode: "Copiar Código",
      finish:
        "Ao finalizar o pagamento, retorne para esta tela para finalizar o pedido",
    },

    securityCheck: {
      invoice: "Fatura",
      authentication: "Autenticação de compra",
      text: "Para confirmar seu pedido, verifique em sua fatura ou em mensagem enviada pelo seu banco, o código de autorização da compra de 3 dígitos:",
      cannotSee: "Não consegui visualizar o código",
      cannotSeeTextOne:
        "Neste caso faremos o estorno da pré-autorização feita no cartão de final ",
      cannotSeeTextTwo:
        ", e você poderá realizar a compra com outro meio de pagamento",
      changePaymentMethod: "Alterar forma de pagamento",
      whySeeing: "Porque estou vendo essa mensagem?",
      becauseSeeing:
        "Para confirmar seu pagamento, precisamos autenticar que você é o portador do cartão utilizado na compra",
    },

    payment: {
      purchasePolicy: "Política de compra",
      buyerData: "Dados do Comprador",
      howWantPay: "Pagamento",
      cancelFree: "Cancelamento grátis até ",
      notStored:
        "Fique tranquilo! Seus dados de pagamento não ficarão armazenados!",
      multipleParcelBillet: "Pague a primeira parcela até o dia",
      oneParcelBillet: "Pague em até um dia útil",
      form: {
        fullName: "Nome Completo",
        corporateName: "Razão Social",
        typeDocument: "Tipo de Documento",
        nationality: "Nacionalidade",
        passport: "Passaporte",
      },
      card: {
        creditCard: "Cartão de Crédito",
        payBy: "Pague em até ",
        installment: "Parcelamento",
        includesInterestFrom: "Inclui juros de ",
        number: "Número do cartão",
        validDate: "Data de validade",
        securityCode: "Código de segurança",
        securityCodeAbbrev: "Código de seg.",
        namePrinted: "Nome impresso no cartão",
        perMonth: "a.m.",
      },
      billet: {
        title: "Boleto",
        fullName: "Nome Completo",
        corporateName: "Razão Social",
      },
    },

    finished: {
      organizerMessage: "Mensagem do Organizador",
      eventOrganizedBy: "Evento organizado por",
      summaryOrder: "Resumo do seu Pedido #",
      accessEvent: "Acessar o evento",
      orderPlaced: "Pedido efetuado!",
      orderAnalysis: "Pedido em Análise",
      detailsOrder: "Os detalhes da sua compra foram enviados para ",
      detailsOrderAnalysis:
        "O seu pagamento está sendo análisado junto à operadora do cartão. Enviaremos uma confirmação via e-mail quando o status do seu pagamento mudar.",
      digitalTicket: "Ingresso Digital",
      courtesy: "Cortesia",
      courtesyText: "Nenhuma cobrança foi realizada",
      ticketsSent: "Seus ingressos foram enviados para o email ",
      notReceived:
        "Caso não tenha recebido o email, acesse/crie sua conta para acessar seus ingressos.",
      seeTickets: "Ver Ingressos",
      accessAccount: "Acessar Conta",
      orderBalance: "Este pedido ainda possui um saldo de ",
      toSwitchOff: " à pagar",
      newPayment:
        "Para realizar um novo pagamento nesse pedido, acesse o link abaixo",
      makeNewPayment: "Fazer novo pagamento",
      copyLink: "Copiar Link",
      billet: {
        payTheBill: "Pague o boleto até o dia ",
        pendingPayment: "Pagamento Pendente",
        threeDays: "Até 3 dias úteis para confirmação do pagamento",
        seeBillet: "Ver boleto",
      },
      card: {
        youPay: "Você pagou ",
        analysis: "Em Análise",
        approved: "Aprovado",
        inCard: "x no cartão terminado em ",
        purchaseReview:
          "Sua compra está em análise. Enviaremos uma confirmação por e-mail quando o status do seu pedido mudar",
      },
      pix: {
        approved: "Aprovado",
        orderValue: "Valor do Pedido: ",
      },
    },

    errors: {
      required: "Campo obrigatório",
      invalid: " inválido",
      invalidDate: "Data inválida.",
      sixCharacters: "Mínimo de 6 caracteres.",
    },
  },

  // ESPANHOL

  es: {
    general: {
      yes: "Si",
      no: "No",
      unavailable: "Indisponible",
      locationToBeDefined: "Ubicación por definir",
      installments: "Cuotas",
      processingFee: "Tarifa de procesamiento",
      processingFeeDescription:
        "La tarifa de procesamiento tiene como objetivo cubrir el costo financiero relacionado con el método de pago elegido.",
      document: "Documento",
      number: "Número",
      phone: "Teléfono",
      cityUf: "Ciudad/UF",
      roadAvenue: "Calle, Avenida...",
      complement: "Complementar",
      neighborhood: "Vecindario",
      city: "Ciudad",
      state: "Estado",
      country: "País",
      tickets: "Entradas",
      cep: "Código Postal",
    },

    header: {
      logout: "Salir",
      help: "Ayuda",
    },

    cart: {
      tickets: "Entradas",
      ticket: "Entrada",
      continue: "Continuar",
      doYouWishContinue: "¿Quieres continuar de todos modos?",
      alertChangeSector:
        "Al cambiar de sector, perderá los billetes reservados hasta el momento.",
      yes: "Si",
      keepBuying: "No, sigue comprando",
      removeReserved: "¿Eliminar boletos reservados?",
      cancelCartTitle: "Cancelar carrito",
      cancelCartDescription: "¿Está seguro de que desea cancelar su carrito?",
      locationMap: "Mapa de localización",
      applyCoupon: "Aplicar un código",
      nothingTickets: "Ningún boleto seleccionado",
      apply: "Aplicar",
      code: "Código ",
      closed: "Cerrado",
      subtitle: "Subtitular",
      proof: "* Se puede solicitar comprobante el día del evento.",
      specialSeats: "Asientos especiales*",
      sectors: "Sectores",
      cartRemove: "Eliminar del Carrito",
    },

    summary: {
      yourOrder: "Su pedido",
      nothingProducts: "Aún no hay entradas seleccionadas.",
      edit: "Editar",
      confirm: "Confirmar",
      balanceToPay: "Saldo a Pagar",
      amountPaid: "Valor Pago",
      ticketsTotal: "Entradas totales",
      serviceTax: "Tasa de servicio",
    },

    participants: {
      participants: "Participantes",
      details: "Nombra cada entrada con la que accederás al evento.",
      jump: "Saltar",
      optional:
        "Opcional. Puede completar los datos del participante más tarde",
      back: "Volver",
      continue: "Continuar",
    },

    preSale: {
      title: "¡Este evento está en Pre-Venta!",
      text: "Ingrese su código especial de pre-pedido a continuación para comenzar su compra:",
    },

    queue: {
      youAreInQueue: "Estás en la cola virtual para comprar entradas",
      pageOpen:
        "Por favor, mantenga esta página abierta. No es necesario recargar.",
      yourPosition: "Tu posición en la cola:",
      yourTurn: "¡Ha llegado tu turno!",
      chooseTickets: "Elige entradas...",
    },

    countdown: {
      finishBy: "Terminar por",
    },

    expiration: {
      expiredOrder: "Orden vencida",
      text: "¡Reinicia tu compra y asegura tus entradas!",
      close: "Cerrar",
    },

    changeBuyer: {
      change: "Cambiar",
      changeBuyer: "Cambiar comprador",
      textOne:
        "Para cambiar sus datos, deberá cambiar los datos de su cuenta en el sitio.",
      textTwo:
        "Si desea realizar esta compra con otros datos del comprador, cierre sesión en su cuenta haciendo clic en el botón a continuación:",
      logout: "Cerrar sesión",
    },

    partialPayment: {
      amountPayable: "Valor a Pagar",
      sharePayment: "Comparta este pago con otros haciendo un pago parcial.",
      moreInfo: "Mas informaciones",
      value: "Valor",
      descriptionTitle:
        "Para dividir el pago con otras personas, ingrese un monto parcial en el campo monto a pagar",
      descriptionOne:
        "Su pago será procesado y su compra quedará pendiente hasta que se haya pagado la totalidad del importe del pedido.",
      descriptionTwo:
        "Recibirá un enlace para compartir y permitir que otros agreguen pagos a su pedido.",
      close: "Cerrar",
    },

    securityCheck: {
      invoice: "Factura",
      authentication: "Autenticación de compra",
      text: "Para confirmar su pedido, verifique en su factura o mensaje enviado por su banco el código de autorización de compra de 3 dígitos:",
      cannotSee: "no pude ver el codigo",
      cannotSeeTextOne:
        "En este caso, revertiremos la preautorización realizada en la tarjeta final. ",
      cannotSeeTextTwo: ", y puedes realizar la compra con otro método de pago",
      changePaymentMethod: "Cambiar método de pago",
      whySeeing: "¿Por qué veo este mensaje?",
      becauseSeeing:
        "Para confirmar su pago, necesitamos autenticar que usted es el titular de la tarjeta utilizada para la compra.",
    },

    pixScreen: {
      choosePaymentMethod: "Elige otro método de pago",
      payWith: "Pagar con",
      waitPlease: "Espere por favor...",
      copyCode: "Copiar Código",
      finish:
        "Después de completar el pago, regrese a esta pantalla para finalizar el pedido.",
    },

    payment: {
      purchasePolicy: "Política de compra",
      buyerData: "Datos del comprador",
      howWantPay: "Pago",
      cancelFree: "Cancelación gratuita hasta ",
      notStored:
        "¡Quédate tranquilo! ¡Sus detalles de pago no serán almacenados!",
      multipleParcelBillet: "Paga la primera cuota al día",
      oneParcelBillet: "Pague dentro de un día hábil",
      form: {
        fullName: "Nombre completo",
        corporateName: "Nombre Corporativo",
        typeDocument: "Tipo de Documento",
        nationality: "Nacionalidad",
        passport: "Pasaporte",
      },
      card: {
        creditCard: "Tarjeta de crédito",
        payBy: "Pagado por ",
        installment: "Entrega",
        includesInterestFrom: "Incluye intereses de ",
        number: "Numero de tarjeta",
        validDate: "Fecha de validez",
        securityCode: "Código de seguridad",
        securityCodeAbbrev: "Código de seg.",
        namePrinted: "Nombre impreso en tarjeta",
        perMonth: "/mes",
      },
      billet: {
        title: "Boleto",
        fullName: "Nombre completo",
        corporateName: "Razón social",
      },
    },

    finished: {
      organizerMessage: "Mensaje del organizador",
      eventOrganizedBy: "Evento organizado por",
      summaryOrder: "Resumen de su orden #",
      accessEvent: "Accede al evento",
      orderPlaced: "Pedido realizado!",
      orderAnalysis: "Pedido en Análisis",
      detailsOrder: "Los detalles de su compra han sido enviados a",
      detailsOrderAnalysis:
        "O seu pagamento está sendo análisado junto à operadora do cartão. Enviaremos uma confirmação via e-mail quando o status do seu pagamento mudar.",
      digitalTicket: "Billete digital",
      ticketsSent: "Sus boletos han sido enviados al correo electrónico ",
      notReceived:
        "Si no ha recibido el correo electrónico, inicie sesión/cree su cuenta para acceder a sus entradas.",
      seeTickets: "Ver entradas",
      accessAccount: "Acceder a la cuenta",
      orderBalance: "Este pedido todavía tiene un saldo de ",
      toSwitchOff: " apagar",
      newPayment:
        "Para realizar un nuevo pago en este pedido, visite el siguiente enlace",
      makeNewPayment: "hacer un nuevo pago",
      copyLink: "Copiar Link",
      billet: {
        payTheBill: "Pagar la factura por día ",
        pendingPayment: "Pago pendiente",
        threeDays: "Hasta 3 días hábiles para confirmación de pago",
        seeBillet: "Ver billete",
      },
      card: {
        youPay: "Tu pagaste ",
        analysis: "En análisis",
        approved: "Aprobado",
        inCard: "x en la tarjeta que termina en ",
        purchaseReview:
          "Su compra está bajo revisión. Le enviaremos una confirmación por correo electrónico cuando cambie el estado de su pedido",
      },
      pix: {
        approved: "Aprobado",
        orderValue: "Valor del pedido: ",
      },
    },

    errors: {
      required: "Campo obligatorio",
      invalid: " inválido",
      invalidDate: "Fecha invalida.",
      sixCharacters: "Mínimo de 6 caracteres.",
    },
  },
};

const i18n = new VueI18n({
  locale: "pt", // set locale
  fallbackLocale: "en", // set fallback locale
  messages, // set locale messages
});

export default i18n;
